import React, { useEffect, useState } from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Login from "../containers/Login";
import { useDispatch, useSelector } from "react-redux";
import UserLayout from "../containers/UserLayout";
import { CustomLayout } from "../containers/Layout";
import Cookies from "universal-cookie";
import { Home } from "../containers/component/Home";
import { authSuccess } from "../app/Actions/auth";
import { getSystemInfo, getUserInfo } from "../app/Reducers/getUserInfo";
import {
  getSystemOTStatus,
  getSystemStatus,
} from "../app/Reducers/getSystemInfo";
import NotPermission from "../containers/notPermission";
import NotFoundLayout from "../containers/notfound";
import { NotValidTime } from "../containers/notValidTime";
import { DeNghiChamCong } from "../containers/component/DeNghiChamCong";
import { LichLamViec } from "../containers/component/Chamcong/LichLamViec";
import { BangChamCongChiTiet } from "../containers/component/Chamcong/BangChamCongChiTiet";
import { QuanLyDeNghiChamCong } from "../containers/component/Chamcong/QuanLyDeNghiChamCong";
import { Overtime } from "../containers/component/Chamcong/Overtime";
import { DanhSachNgayLe } from "../containers/component/Hr/DanhSachNgayLe";
import { TongHopNgayNghi } from "../containers/component/Hr/TongHopNgayNghi";
import { TongHopCong } from "../containers/component/Hr/TongHopCong";
import { BangChamCongChiTietNhanSu } from "../containers/component/Hr/BangChamCongChiTiet";
import { OvertimeNhanSu } from "../containers/component/Hr/Overtime";
import { ChotCong } from "../containers/component/Hr/ChotCong";
import { DanhSachNhanVien } from "../containers/component/Hr/DanhSachNhanVien";
import { BangPhep } from "../containers/component/Hr/BangPhep";
import { CauHinhHeThong } from "../containers/component/CauHinh/CauHinhHeThong";
import { CamKetWFH } from "../containers/component/CamKetWFH";
import { CamKetWFH_QL } from "../containers/component/Chamcong/CamKetWFH";
import { CamKetWFH_NS } from "../containers/component/Hr/CamKetWFH";
import { QuanLyTongHopCong } from "../containers/component/Chamcong/QuanLyTongHopCong";
import { BangPhep_QL } from "../containers/component/Chamcong/QuanLyBangPhep";
import { NhanSuDeNghiChamCong } from "../containers/component/Hr/DeNghiChamCong";

// import { DanhSachNhanVien_Test } from "../containers/component/Hr/DanhSachNhanVien_Test";
// import {LichLamViec_Test} from "../containers/component/Chamcong/LichLamViec_Test";
import Renewpass from "../containers/Renewpass";
import { OvertimeSpecial } from "../containers/component/Hr/Overtime_special";
import ThiISMS from "containers/component/Chamcong/ThiISMS";
import ViewQuestion from "containers/component/ISMS/ViewQuestion/ViewQuestion";
import ViewGroup from "containers/component/ISMS/ViewGroup/ViewGroup";
import ViewExam from "containers/component/ISMS/ViewExam/ViewExam";
import ViewResultExam from "containers/component/ISMS/ViewResultExam/ViewResultExam";
import ViewDocument from "containers/component/ISMS/ViewDocument/ViewDocument";

// import { userInfoURL } from '../constants';
// import { authAxios } from '../api/axiosClient';

const cookies = new Cookies();

function Main() {
  const dispatch = useDispatch();
  const [isValid, setIsValid] = useState(true);
  const [lsPermissions, setLsPermissions] = useState([]);
  const token = cookies.get("token");

  if (token) {
    dispatch(authSuccess(token));
  }
  const auth = useSelector((state) => state.auth.token) !== null;
  const systemTime = useSelector((state) => state.getUserInfo.timeSystem);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  useEffect(() => {
    if (systemTime) {
      // setIsValid((Math.abs(new Date(systemTime).getTime() - new Date().getTime())/1000/60) <= 720);
    }
  }, [systemTime]);

  useEffect(() => {
    if (auth && token) {
      dispatch(getUserInfo(token));
      dispatch(getSystemInfo(token));
      dispatch(getSystemStatus(token));
      dispatch(getSystemOTStatus(token));
    }
  }, [auth, token]);

  useEffect(() => {
    if (userInfo) {
      if (userInfo.team_permissions) {
        const arrTeam = userInfo.team_permissions.map(
          (item, index) => item.phanquyen__ten_pq,
        );
        setLsPermissions([...userInfo.user_permissions, ...new Set(arrTeam)]);
      } else {
        setLsPermissions(userInfo.user_permissions);
      }
    }
    // console.log(userInfoURL);
    // if (userInfo && userInfo.user_permissions) {
    //     setLsPermissions(userInfo.user_permissions)
    // }
    // authAxios().get(userInfoURL).then(r=>{
    //     console.log(r.data.user_permissions);
    //     setLsPermissions(r.data.user_permissions);
    // })
  }, [userInfo]);

  return (
    <Router>
      <Switch>
        <Route exact path="/renewpass/:tok" component={Renewpass} />

        <ProtectLoginRoute exact path="/login" protect={auth}>
          <UserLayout>
            <Login />
          </UserLayout>
        </ProtectLoginRoute>

        <RouteWithLayout
          component={Home}
          exact
          layout={CustomLayout}
          path="/"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["personalTimesheet_view"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={Home}
          exact
          layout={CustomLayout}
          path="/ca-nhan"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["personalTimesheet_view"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={DeNghiChamCong}
          exact
          layout={CustomLayout}
          path="/ca-nhan/de-nghi-cham-cong"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["attendanceRequest_view"]}
          isLogged={auth}
          isValid={isValid}
        />
        {/* <RouteWithLayout
          component={CamKetWFH}
          exact
          layout={CustomLayout}
          path="/ca-nhan/dang-ky-lam-wfh"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_wfh_commit"]}
          isLogged={auth}
          isValid={isValid}
        /> */}
        <RouteWithLayout
          component={ThiISMS}
          exact
          layout={CustomLayout}
          path="/ca-nhan/thi-isms"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["personalTimesheet_view"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={ViewExam}
          exact
          layout={CustomLayout}
          path="/isms/exam"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["isms_hr"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={ViewResultExam}
          exact
          layout={CustomLayout}
          path="/isms/result-exam"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["isms_hr"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={ViewQuestion}
          exact
          layout={CustomLayout}
          path="/isms/question"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["isms_hr"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={ViewDocument}
          exact
          layout={CustomLayout}
          path="/isms/document"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["isms_hr"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={ViewGroup}
          exact
          layout={CustomLayout}
          path="/isms/group"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["isms_hr"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={QuanLyDeNghiChamCong}
          exact
          layout={CustomLayout}
          path="/cham-cong/danh-sach-de-nghi/"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["attendanceRequest_view_xx"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={LichLamViec}
          exact
          layout={CustomLayout}
          path="/cham-cong/lich-lam-viec"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["set_working_schedule_xx"]}
          isLogged={auth}
          isValid={isValid}
        />
        {/* <RouteWithLayout
                    component={LichLamViec_Test}
                     exact
                     layout={CustomLayout}
                     path="/cham-cong/lich-lam-viec-test"
                     isPrivate={true}
                     lsPermissions={lsPermissions}
                     permission={['set_working_schedule_xx']}
                     isLogged={auth}
                    isValid={isValid}
                /> */}
        <RouteWithLayout
          component={Overtime}
          exact
          layout={CustomLayout}
          path="/cham-cong/overtime"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["overtime_view"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={BangChamCongChiTiet}
          exact
          layout={CustomLayout}
          path="/cham-cong/bang-cham-cong-chi-tiet"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["detailed_timesheet_view"]}
          isLogged={auth}
          isValid={isValid}
        />
        {/* <RouteWithLayout
          component={CamKetWFH_QL}
          exact
          layout={CustomLayout}
          path="/cham-cong/dang-ky-lam-wfh"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["wfh_commit_view"]}
          isLogged={auth}
          isValid={isValid}
        /> */}
        <RouteWithLayout
          component={BangPhep_QL}
          exact
          layout={CustomLayout}
          path="/cham-cong/ql-bang-phep"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_leave_date_xx", "is_leave_date_pd"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={QuanLyTongHopCong}
          exact
          layout={CustomLayout}
          path="/cham-cong/tong-hop-cong"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["working_consolidation_view_ql"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={DanhSachNgayLe}
          exact
          layout={CustomLayout}
          path="/nhan-su/danh-sach-ngay-le"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_declare_holiday_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={TongHopNgayNghi}
          exact
          layout={CustomLayout}
          path="/nhan-su/total-ngay-nghi"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_declare_sumholiday_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={OvertimeNhanSu}
          exact
          layout={CustomLayout}
          path="/nhan-su/overtime"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["overtime_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={OvertimeSpecial}
          exact
          layout={CustomLayout}
          path="/nhan-su/overtime-special"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["overtime_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={BangChamCongChiTietNhanSu}
          exact
          layout={CustomLayout}
          path="/nhan-su/bang-cham-cong-chi-tiet"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["detailed_timesheet_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={NhanSuDeNghiChamCong}
          exact
          layout={CustomLayout}
          path="/nhan-su/danh-sach-de-nghi/"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["detailed_timesheet_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={TongHopCong}
          exact
          layout={CustomLayout}
          path="/nhan-su/tong-hop-cong"
          lsPermissions={lsPermissions}
          isPrivate={true}
          permission={["working_consolidation_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={ChotCong}
          exact
          layout={CustomLayout}
          path="/nhan-su/chot-cong"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["working_final_view"]}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={BangPhep}
          exact
          layout={CustomLayout}
          path="/nhan-su/bang-phep"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["leave_dashboard_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        {/* <RouteWithLayout
          component={CamKetWFH_NS}
          exact
          layout={CustomLayout}
          path="/nhan-su/dang-ky-lam-wfh"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_wfh_commit_ns"]}
          isLogged={auth}
          isValid={isValid}
        /> */}
        <RouteWithLayout
          component={DanhSachNhanVien}
          exact
          layout={CustomLayout}
          path="/cau-hinh/danh-sach-nguoi-dung"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_declare_employees_ns"]}
          isLogged={auth}
          isValid={isValid}
        />
        {/* <RouteWithLayout
          component={DanhSachNhanVien_Test}
          exact
          layout={CustomLayout}
          path="/cau-hinh/danh-sach-nguoi-dung-test"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_declare_employees_ns"]}
          isLogged={auth}
          isValid={isValid}
        /> */}

        <RouteWithLayout
          component={CauHinhHeThong}
          exact
          layout={CustomLayout}
          path="/cau-hinh/cau-hinh-he-thong"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={["is_declare_employees_ns", "is_admin"]}
          isLogged={auth}
          isValid={isValid}
        />

        <RouteWithLayout
          component={NotPermission}
          exact
          layout={CustomLayout}
          path="/notpermission"
          isPrivate={true}
          lsPermissions={lsPermissions}
          permission={"403"}
          isLogged={auth}
          isValid={isValid}
        />
        <RouteWithLayout
          component={NotFoundLayout}
          layout={CustomLayout}
          path="/"
          lsPermissions={lsPermissions}
          isPrivate={true}
          isLogged={auth}
          permission={"404"}
          isValid={isValid}
        />
      </Switch>
    </Router>
  );
}

const RouteWithLayout = (props) => {
  const {
    layout: Layout,
    isLogged: isLogged,
    component: Component,
    isPrivate: isPrivate,
    isValid: isValid,
    lsPermissions: lsPermissions,
    permission: permission,
    ...rest
  } = props;
  const getRejectRoute = (type) => {
    switch (type) {
      case "403":
        return <NotPermission />;
      case "404":
        return <NotFoundLayout />;
      default:
        return <NotPermission />;
    }
  };
  return (
    <Route
      {...rest}
      render={() =>
        isValid ? (
          isPrivate ? (
            isLogged ? (
              lsPermissions && lsPermissions.length > 0 ? (
                lsPermissions.some((r) => permission.includes(r)) ? (
                  <Layout isLogged={isLogged}>
                    <Component {...props} />
                  </Layout>
                ) : (
                  getRejectRoute(permission)
                )
              ) : (
                <span></span>
              )
            ) : (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: props.location },
                }}
              />
            )
          ) : (
            <Layout isLogged={isLogged}>
              <Component {...props} />
            </Layout>
          )
        ) : (
          <NotValidTime isValid={isValid} />
        )
      }
    />
  );
};

const ProtectLoginRoute = ({ protect, children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => (!protect ? children : <Redirect to="/ca-nhan"></Redirect>)}
    />
  );
};

export default Main;
